import React from 'react'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { ProjectCourseFeature } from '../../features/ProjectCourseFeature'
import { Box } from '@mui/material'

const Page = (): JSX.Element => {
  return (
    <>
      <Box display='flex' flexDirection='column' gap={6}>
        <CustomHeader title={PAGE_TITLES.DISTRIBUTION_SERIES} />
        <ProjectCourseFeature />
      </Box>
    </>
  )
}

export default Page
